export default "__VITE_ASSET__5bFOxXDe__"